const solarPaket = [
  {
    "title": "TommaTech Yürüyüş Yolu Solar Led Aydınlatma",
    "image": "https://cw-enerji.com/images/kategory_grup/148_tommatech-yuruyus-yolu-solar-led-aydinlatma.webp",
    "text": "Yüksek Performans\nGüvenli Yapı\nMicrodalga Sensör\nAkıllı Güç Yönetim Sistemi\nIP65 Koruma Sınıfı\nLFP Batarya Teknolojisi\nOtonomi Süresi 1-2 Gün",
    "variants": [
      {
        "wp": "20",
        "link": "https://cw-enerji.com/tr/urun/tommatech-yuruyus-yolu-solar-led-aydinlatma-4m-20w-1400.html"
      }
    ]
  },
  {
    "title": "TommaTech Yol / Sokak Solar Led Aydınlatma",
    "image": "https://cw-enerji.com/images/kategory_grup/159_tommatech-yol-sokak-solar-led-aydinlatma.webp",
    "text": "Yüksek Performans\nGüvenli Yapı\nMicrodalga Sensör\nAkıllı Güç Yönetim Sistemi\nIP65 Koruma Sınıfı\nLFP Batarya Teknolojisi\nOtonomi Süresi Min. 2 Gün",
    "variants": [
      {
        "wp": "90 W",
        "link": "https://cw-enerji.com/tr/urun/tommatech-yol-sokak-solar-led-aydinlatma-90w-1520.html"
      },
      {
        "wp": "58 W",
        "link": "https://cw-enerji.com/tr/urun/tommatech-yol-sokak-solar-led-aydinlatma-58w-1519.html"
      },
      {
        "wp": "36 W",
        "link": "https://cw-enerji.com/tr/urun/tommatech-yol-sokak-solar-led-aydinlatma-36w-1518.html"
      },
      {
        "wp": "20 W",
        "link": "https://cw-enerji.com/tr/urun/tommatech-yol-sokak-solar-led-aydinlatma-20w-1517.html"
      }
    ]
  },
  {
    "title": "TommaTech ECO SERIES Yürüyüş Yolu Solar Led Aydınlatma",
    "image": "https://cw-enerji.com/images/kategory_grup/169_tommatech-eco-series-yuruyus-yolu-solar-led-aydinlatma.webp",
    "text": "Yüksek Performans\nMicrodalga Sensör\nIP65 Koruma Sınıfı\nGüvenli Yapı\nAkıllı Güç Yönetim Sistemi\nLFP Batarya Teknolojisi",
    "variants": [
      {
        "wp": "20",
        "link": "https://cw-enerji.com/tr/urun/tommatech-eco-series-yuruyus-yolu-solar-led-aydinlatma-20w-1564.html"
      },
      {
        "wp": "10",
        "link": "https://cw-enerji.com/tr/urun/tommatech-eco-series-yuruyus-yolu-solar-led-aydinlatma-10w-1563.html"
      }
    ]
  },
  {
    "title": "CW Enerji Isıtmalı Solar Ceket Small - 3XLarge",
    "image": "https://cw-enerji.com/images/kategory_grup/190_cw-enerji-isitmali-solar-ceket-small-3xlarge.webp",
    "text": "IBC Hücre Teknolojisi\nSoftshell Mont\nUltra Hafif\nPowerbank\nSıcaklık Kontrolü\nETFE ile Mükemmel Işık Geçirgenliği\nPrizma Yüzey\nTak-Çıkar Kolay Kullanım",
    "variants": [
      {
        "wp": "3XLarge",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-isitmali-solar-ceket-3xlarge-1761.html"
      },
      {
        "wp": "2XLarge",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-isitmali-solar-ceket-2xlarge-1760.html"
      },
      {
        "wp": "Medium",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-isitmali-solar-ceket-medium-1757.html"
      },
      {
        "wp": "Large",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-isitmali-solar-ceket-large-1758.html"
      },
      {
        "wp": "XLarge",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-isitmali-solar-ceket-xlarge-1759.html"
      },
      {
        "wp": "Small",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-isitmali-solar-ceket-small-1387.html"
      }
    ]
  },
  {
    "title": "Tek Faz 5kWe On Grid Medium Paket",
    "image": "https://cw-enerji.com/images/product/1720_tek-faz-5kwe-on-grid-medium-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "TommaTech 1 Araçlık Solar Otopark Paketi 590Wp",
    "image": "https://cw-enerji.com/images/product/1548_tommatech-1-araclik-solar-otopark-paketi-590wp_0.webp",
    "text": "Temiz ve sonsuz güneş enerjisinin kullanım ve uygulama alanlarının arttırılması amacıyla dizayn edilen,\nTommaTech Güneş  Enerjili Otoparklar “Solar Carport” kullanıcılara akıllı çözümler sunmaktadır.",
    "variants": []
  },
  {
    "title": "TommaTech 1 Araçlık Solar Otopark Paketi 430Wp",
    "image": "https://cw-enerji.com/images/product/1546_tommatech-1-araclik-solar-otopark-paketi-430wp_0.webp",
    "text": "Temiz ve sonsuz güneş enerjisinin kullanım ve uygulama alanlarının arttırılması amacıyla dizayn edilen,\nTommaTech Güneş  Enerjili Otoparklar “Solar Carport” kullanıcılara akıllı çözümler sunmaktadır.",
    "variants": []
  },
  {
    "title": "TommaTech 2 Araçlık Solar Otopark Paketi 430Wp",
    "image": "https://cw-enerji.com/images/product/1547_tommatech-2-araclik-solar-otopark-paketi-430wp_0.webp",
    "text": "Temiz ve sonsuz güneş enerjisinin kullanım ve uygulama alanlarının arttırılması amacıyla dizayn edilen,\nTommaTech Güneş  Enerjili Otoparklar “Solar Carport” kullanıcılara akıllı çözümler sunmaktadır.",
    "variants": []
  },
  {
    "title": "TommaTech 2 Araçlık Solar Otopark Paketi 590Wp",
    "image": "https://cw-enerji.com/images/product/1549_tommatech-2-araclik-solar-otopark-paketi-590wp_0.webp",
    "text": "Temiz ve sonsuz güneş enerjisinin kullanım ve uygulama alanlarının arttırılması amacıyla dizayn edilen,\nTommaTech Güneş  Enerjili Otoparklar “Solar Carport” kullanıcılara akıllı çözümler sunmaktadır.",
    "variants": []
  },
  {
    "title": "Üç Faz 6kWe Hibrit Large Paket",
    "image": "https://cw-enerji.com/images/product/1739_uc-faz-6kwe-hibrit-large-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Tek Faz 5kWe On Grid Small Paket",
    "image": "https://cw-enerji.com/images/product/1718_tek-faz-5kwe-on-grid-small-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Tek Faz 5kWe On Grid Large Paket",
    "image": "https://cw-enerji.com/images/product/1721_tek-faz-5kwe-on-grid-large-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 5kWe On Grid Small Paket",
    "image": "https://cw-enerji.com/images/product/1722_uc-faz-5kwe-on-grid-small-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 5kWe On Grid Medium Paket",
    "image": "https://cw-enerji.com/images/product/1723_uc-faz-5kwe-on-grid-medium-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 5kWe On Grid Large Paket",
    "image": "https://cw-enerji.com/images/product/1724_uc-faz-5kwe-on-grid-large-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 10kWe Trio Atom On Grid Small Paket",
    "image": "https://cw-enerji.com/images/product/1725_uc-faz-10kwe-trio-atom-on-grid-small-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 10kWe Trio Atom On Grid Medium Paket",
    "image": "https://cw-enerji.com/images/product/1726_uc-faz-10kwe-trio-atom-on-grid-medium-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 10kWe Trio Atom On Grid Large Paket",
    "image": "https://cw-enerji.com/images/product/1727_uc-faz-10kwe-trio-atom-on-grid-large-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 10kWe Trio Plus On Grid Small Paket",
    "image": "https://cw-enerji.com/images/product/1728_uc-faz-10kwe-trio-plus-on-grid-small-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 15kWe On Grid Large Paket",
    "image": "https://cw-enerji.com/images/product/1733_uc-faz-15kwe-on-grid-large-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 10kWe Trio Plus On Grid Medium Paket",
    "image": "https://cw-enerji.com/images/product/1729_uc-faz-10kwe-trio-plus-on-grid-medium-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 10kWe Trio Plus On Grid Large Paket",
    "image": "https://cw-enerji.com/images/product/1730_uc-faz-10kwe-trio-plus-on-grid-large-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 15kWe On Grid Small Paket",
    "image": "https://cw-enerji.com/images/product/1731_uc-faz-15kwe-on-grid-small-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 15kWe On Grid Medium Paket",
    "image": "https://cw-enerji.com/images/product/1732_uc-faz-15kwe-on-grid-medium-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Tek Faz 6kWe Hibrit Small Paket",
    "image": "https://cw-enerji.com/images/product/1734_tek-faz-6kwe-hibrit-small-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Tek Faz 6kWe Hibrit Medium Paket",
    "image": "https://cw-enerji.com/images/product/1735_tek-faz-6kwe-hibrit-medium-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Tek Faz 6kWe Hibrit Large Paket",
    "image": "https://cw-enerji.com/images/product/1736_tek-faz-6kwe-hibrit-large-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 6kWe Hibrit Small Paket",
    "image": "https://cw-enerji.com/images/product/1737_uc-faz-6kwe-hibrit-small-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 6kWe Hibrit Medium Paket",
    "image": "https://cw-enerji.com/images/product/1738_uc-faz-6kwe-hibrit-medium-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 10kWe Hibrit Small Paket",
    "image": "https://cw-enerji.com/images/product/1740_uc-faz-10kwe-hibrit-small-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 10kWe Hibrit Medium Paket",
    "image": "https://cw-enerji.com/images/product/1741_uc-faz-10kwe-hibrit-medium-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 10kWe Hibrit Large Paket",
    "image": "https://cw-enerji.com/images/product/1742_uc-faz-10kwe-hibrit-large-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 15kWe Hibrit Small Paket",
    "image": "https://cw-enerji.com/images/product/1743_uc-faz-15kwe-hibrit-small-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 15kWe Hibrit Medium Paket",
    "image": "https://cw-enerji.com/images/product/1744_uc-faz-15kwe-hibrit-medium-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "Üç Faz 15kWe Hibrit Large Paket",
    "image": "https://cw-enerji.com/images/product/1745_uc-faz-15kwe-hibrit-large-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "18 Panel(425Wp) 7.2kWe Off-Grid(48V) Solar Paket",
    "image": "https://cw-enerji.com/images/product/1494_18-panel425wp-72kwe-off-grid48v-solar-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "26 Panel(425Wp) 11kWe Off-Grid(48V) Solar Paket",
    "image": "https://cw-enerji.com/images/product/1496_26-panel425wp-11kwe-off-grid48v-solar-paket_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "TommaTech 300We 1x240Wp Mikro İnverter Balkon Seti",
    "image": "https://cw-enerji.com/images/product/1320_tommatech-300we-1x250wp-mikro-inverter-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "TommaTech 300We 2x240Wp Mikro İnverter Balkon Seti",
    "image": "https://cw-enerji.com/images/product/1321_tommatech-300we-2x250wp-mikro-inverter-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "2 Panel(110Wp) 1kWe Off-Grid(12V) Solar Paket",
    "image": "https://cw-enerji.com/images/product/1126_2-panel110wp-1kwe-off-grid12v-solar-paket_0.webp",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "4 Panel(170Wp) 3kWe Off-Grid(24V) Solar Paket",
    "image": "https://cw-enerji.com/images/product/1129_4-panel170wp-3kwe-off-grid24v-solar-paket_0.webp",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "3 Panel(110Wp) 1kWe Off-Grid(12V) Solar Paket",
    "image": "https://cw-enerji.com/images/product/1127_3-panel110wp-1kwe-off-grid12v-solar-paket_0.webp",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "2 Panel(170Wp) 3kWe Off-Grid(24V) Solar Paket",
    "image": "https://cw-enerji.com/images/product/1128_2-panel170wp-3kwe-off-grid24v-solar-paket_0.webp",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacınızı karşılayabilirsiniz.",
    "variants": []
  },
  {
    "title": "CW Enerji 96Wp/172Wh Solar Şemsiye",
    "image": "https://cw-enerji.com/images/product/1427_cw-enerji-96wp172wh-solar-semsiye_0.webp",
    "text": "Kolay Açılıp Kapanan Mekanizmalı Sistem\nKapalı Durumda Otomatik Pil Koruma\n172 Wh Lityum Batarya\nPil Seviye Göstergesi\nUSB ve Type-C Hızlı Şarj Desteği\nAnahtar Kontrollü LED Aydınlatma\n8 Adet Beyaz 4000-5000K LED\nFarklı boyut ve kumaş seçenek",
    "variants": []
  },
  {
    "title": "150HP-110KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1477_150hp-110kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "125HP-90KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1476_125hp-90kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "100HP-75KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1475_100hp-75kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "75HP-55KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1474_75hp-55kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "60HP-45KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1473_60hp-45kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "50HP-37KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1472_50hp-37kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "40HP-30KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1471_40hp-30kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "35HP-26KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1470_35hp-26kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "30HP-22KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1469_30hp-22kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "25HP-18.5KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1468_25hp-185kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "20HP-15KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1467_20hp-15kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "15HP-11KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1466_15hp-11kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "10HP-7.5KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1464_10hp-75kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "7.5HP-5.5KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1463_75hp-55kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "5.5HP-4KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1461_55hp-4kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "4HP-3KW 3 FAZ / 400V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1459_4hp-3kw-3-faz-400v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "3HP-2.2KW 1 FAZ / 230V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1458_3hp-22kw-1-faz-230v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "2HP-1.5KW 1 FAZ / 230V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1457_2hp-15kw-1-faz-230v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "1.5HP-1KW 1 FAZ / 230V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1455_15hp-1kw-1-faz-230v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  },
  {
    "title": "1HP-0.75KW 1 FAZ / 230V Pompa İçin Sulama Paketi",
    "image": "https://cw-enerji.com/images/product/1454_1hp-075kw-1-faz-230v-pompa-icin-sulama-paketi_0.jpg",
    "text": "Solar paketler aracılığıyla rahatlıkla elektrik üretebilir ve elektrik ihtiyacımızı karşılayabiliriz.",
    "variants": []
  }
];

export default solarPaket;
